export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
    }

    showAddToGroups() {
        return this.$state.is('company.user-directories.manage-account.groups-apps');
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/manage-account.controller.js